export default __webpack_public_path__ + "static/media/nav_detail_image_4.f3cde854.png";